import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { pinWebpage } from 'action/webpage'
import PropTypes from 'prop-types'
import confirmModal from 'view/component/confirm-modal'
import { startCase } from 'lodash'
import { Button } from 'antd'
import styles from './styles'

const generateModalText = (title, pinnedText) => ({
  decide: {
    content: '',
    title: `Are you sure you want to ${pinnedText} ${title}?`
  },

  outcome: {
    content: {
      error: 'Please try Again',
      success: `${title} has been successfully ${pinnedText}ned`
    },
    title: {
      error: `There has been an issue ${pinnedText}ning ${title}`,
      success: `Webpage ${pinnedText}ned`
    }
  }
})

const PinWebpage = ({ pinWebpage, webpage: { uuid, title, pinned: isPinned, is_draft: isDraft }, pagination }) => {
  const pinnedText = isPinned ? 'unpin' : 'pin'

  const handleSubmit = () => pinWebpage(uuid)

  const { decide, outcome } = generateModalText(title, pinnedText)

  return (
    <Button
      className={styles.menu_item}
      disabled={isDraft}
      onClick={() => confirmModal(handleSubmit, decide, outcome)}
      type='text'
    >{`${startCase(pinnedText)} Webpage`}</Button>
  )
}

PinWebpage.propTypes = {
  pagination: PropTypes.object,
  pinWebpage: PropTypes.func,
  webpage: PropTypes.object
}

const mapDispatchToProps = (dispatch) => ({
  pinWebpage: bindActionCreators(pinWebpage, dispatch)
})

const mapStateToProps = (state) => ({
  pagination: state.discovery.pagination
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PinWebpage)
